// extracted by mini-css-extract-plugin
module.exports = {"container":"RecommendProduct_container__1ESQ-"};